import { render, staticRenderFns } from "./BIParameterRuleFormPage.vue?vue&type=template&id=3a3344a8&"
import script from "./BIParameterRuleFormPage.vue?vue&type=script&lang=js&"
export * from "./BIParameterRuleFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports